<template>
  <div class="relative flex py-5 items-center">
    <div class="flex-grow border-t border-gray-400"></div>
    <span class="flex-shrink mx-4 text-3xl font-bold">Riwayat Pendidikan</span>
    <div class="flex-grow border-t border-gray-400"></div>
  </div>
  <div class="space-y-4">
    <div
      class="border-b border-gray-900/10 pb-12 px-8 py-20 mt-4 shadow-md rounded-xl bg-white"
    >
      <h2 class="text-base text-gray-800 font-medium font-sans">
        Pendidikan Terakhir
      </h2>
      <p class="text-sm text-gray-500 font-medium pb-6 border-b">
        Informasi pendidikan terakhir
      </p>
      <div class="py-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3">
        <div class="sm:col-span-1 content-center">
          <label
            for="pendidikan_terakhir"
            class="block leading-6 text-gray-600 text-sm font-medium font-sans mt-2"
            >Pendidikan Terakhir</label
          >
        </div>
        <div class="sm:col-span-1">
          <div class="mt-2">
            <select
              id="pendidikan_terakhir"
              name="pendidikan_terakhir"
              :value="modelValue.pendidikan_terakhir"
              @change="updateField('pendidikan_terakhir', $event.target.value)"
              class="block w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            >
              <option disabled selected value="">
                Pilih Pendidikan Terakhir
              </option>
              <option value="SMP">SMP / MTs / sederajat</option>
              <option value="SMA">SMA / MA / sederajat</option>
              <option value="D3">D3</option>
              <option value="S1">S1 Sarjana</option>
              <option value="S2">S2 Magister</option>
              <option value="S3">S3 Doktor</option>
            </select>
          </div>
        </div>
      </div>
      <div
        v-if="
          modelValue.pendidikan_terakhir != 'SMP' &&
          modelValue.pendidikan_terakhir != 'SMA'
        "
        class="py-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3 border-t"
      >
        <div class="sm:col-span-1">
          <label
            for="tahun_lulus"
            class="block leading-6 text-gray-600 text-sm font-medium font-sans pt-1.5"
            >Tahun lulus</label
          >
        </div>
        <div class="sm:col-span-1">
          <div class="">
            <select
              id="tahun_lulus"
              :value="modelValue.tahun_lulus"
              @change="updateField('tahun_lulus', $event.target.value)"
              class="block w-md rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            >
              <option value="" disabled selected>Tahun lulus</option>
              <option v-for="year in graduationYears" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div
        class="py-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3 border-t"
        v-if="
          modelValue.pendidikan_terakhir != 'SMP' &&
          modelValue.pendidikan_terakhir != 'SMA'
        "
      >
        <div class="sm:col-span-1">
          <label
            for="fakultas/jurusan"
            class="block leading-6 text-gray-600 text-sm font-medium font-sans pt-1.5"
            >Fakultas/Jurusan</label
          >
        </div>
        <div class="sm:col-span-2">
          <div class="">
            <input
              id="fakultas/jurusan"
              name="fakultas/jurusan"
              type="text"
              autocomplete="fakultas/jurusan"
              :value="modelValue.fakultas_jurusan"
              @change="updateField('fakultas_jurusan', $event.target.value)"
              class="block max-w-lg w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 peer"
            />
          </div>
        </div>
      </div>
      <div
        class="py-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3 border-t"
        v-if="modelValue.pendidikan_terakhir != 'SMP'"
      >
        <div class="sm:col-span-1">
          <label
            for="sekolah_ma"
            class="block leading-6 text-gray-600 text-sm font-medium font-sans pt-1.5"
            >Nama Sekolah SMA / MA</label
          >
        </div>
        <div class="sm:col-span-2">
          <div class="">
            <input
              id="sekolah_ma"
              name="sekolah_ma"
              type="text"
              autocomplete="sekolah_ma"
              :value="modelValue.sekolah_ma"
              @input="updateField('sekolah_ma', $event.target.value)"
              class="block max-w-lg w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 peer"
            />
          </div>
        </div>
      </div>
      <div
        class="py-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3 border-t"
        v-if="modelValue.pendidikan_terakhir != 'SMP'"
      >
        <div class="sm:col-span-1">
          <label
            for="tahun_lulus_ma"
            class="block leading-6 text-gray-600 text-sm font-medium font-sans pt-1.5"
            >Tahun lulus SMA / MA</label
          >
        </div>
        <div class="sm:col-span-1">
          <div class="">
            <select
              id="tahun_lulus_ma"
              :value="modelValue.tahun_lulus_ma"
              @change="updateField('tahun_lulus_ma', $event.target.value)"
              class="block w-md rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            >
              <option value="" disabled selected>Tahun lulus</option>
              <option v-for="year in graduationYears" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div
        class="py-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3 border-t"
      >
        <div class="sm:col-span-1">
          <label
            for="sekolah_smp"
            class="block leading-6 text-gray-600 text-sm font-medium font-sans pt-1.5"
            >Nama Sekolah SMP / MTs</label
          >
        </div>
        <div class="sm:col-span-2">
          <div class="">
            <input
              id="sekolah_smp"
              name="sekolah_smp"
              type="text"
              autocomplete="sekolah_smp"
              :value="modelValue.sekolah_smp"
              @input="updateField('sekolah_smp', $event.target.value)"
              class="block max-w-lg w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 peer"
            />
          </div>
        </div>
      </div>
      <div
        class="py-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3 border-t"
      >
        <div class="sm:col-span-1">
          <label
            for="tahun_lulus_smp"
            class="block leading-6 text-gray-600 text-sm font-medium font-sans pt-1.5"
            >Tahun lulus SMP / MTs</label
          >
        </div>
        <div class="sm:col-span-1">
          <div class="">
            <select
              id="tahun_lulus_smp"
              :value="modelValue.tahun_lulus_smp"
              @change="updateField('tahun_lulus_smp', $event.target.value)"
              class="block w-md rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            >
              <option value="" disabled selected>Tahun lulus</option>
              <option v-for="year in graduationYears" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <div
        class="py-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3 border-t"
      >
        <div class="sm:col-span-1">
          <label
            for="sekolah_sd"
            class="block leading-6 text-gray-600 text-sm font-medium font-sans pt-1.5"
            >Nama Sekolah SD</label
          >
        </div>
        <div class="sm:col-span-2">
          <div class="">
            <input
              id="sekolah_sd"
              name="sekolah_sd"
              type="text"
              autocomplete="sekolah_sd"
              :value="modelValue.sekolah_sd"
              @input="updateField('sekolah_sd', $event.target.value)"
              class="block max-w-lg w-full rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6 peer"
            />
          </div>
        </div>
      </div>
      <div
        class="py-6 grid grid-cols-1 gap-x-6 gap-y-8 sm:grid-cols-3 border-t"
      >
        <div class="sm:col-span-1">
          <label
            for="tahun_lulus_sd"
            class="block leading-6 text-gray-600 text-sm font-medium font-sans pt-1.5"
            >Tahun lulus SD</label
          >
        </div>
        <div class="sm:col-span-1">
          <div class="">
            <select
              id="tahun_lulus_sd"
              :value="modelValue.tahun_lulus_sd"
              @change="updateField('tahun_lulus_sd', $event.target.value)"
              class="block w-md rounded-md border-0 py-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
            >
              <option value="" disabled selected>Tahun lulus</option>
              <option v-for="year in graduationYears" :key="year" :value="year">
                {{ year }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mt-6 flex items-center justify-end gap-x-6">
    <button
      type="button"
      class="text-sm font-semibold leading-6 text-gray-900"
      @click="prev"
    >
      kembali
    </button>
    <button
      @click="next"
      class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 group-invalid:pointer-events-none group-invalid:opacity-30"
    >
      Selanjutnya
    </button>
  </div>
</template>

<script setup>
import { defineEmits, defineProps, ref, onMounted } from "vue";

const props = defineProps({
  modelValue: Object,
});
const graduationYears = ref([]);
const emit = defineEmits(["prev", "next", "update:modelValue"]);

const updateField = (field, value) => {
  emit("update:modelValue", { ...props.modelValue, [field]: value });
};
onMounted(() => {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 20;

  // Generate array dari startYear hingga currentYear
  for (let year = currentYear; year >= startYear; year--) {
    graduationYears.value.push(year);
  }
});
const next = () => {
  emit("next");
};
const prev = () => {
  emit("prev");
};
</script>

<style></style>
